import React, { useEffect, useContext, useState, useMemo, useCallback } from "react";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import Pagination from "../../CommonUI/Pagination/Pagination";
import pdf from "../../../images/pdf.png";
import excel from "../../../images/excel.png";
import xml from "../../../images/imgxml.png";
import word from "../../../images/word.png";
import animation from '../../../images/jm-animation.gif';
import './DownloadInner.css';
function DownloadInner() {
  const [data, setData] = useState(false);
  const { BaseURL } = useContext(URLstateContext);
  const [Title, setTitle] = React.useState("Fund Fact Sheets");
  const [value, setValue] = React.useState(5);
  const [CategoryId, setCategoryId] = React.useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingshow, setloadingshow] = useState(false);

  const arrayOfTabsObj = [
    { name: "TransactionService related forms", id: 12 },
    { name: "Fund Fact Sheets", id: 5 },
    { name: "PMS Related Documents", id: 9 },
    { name: "Application form", id: 2 },
    { name: "Scheme Related Documents", id: 11 },
    { name: "Addendum", id: 1 },
    { name: "Disclosures", id: 3 },
    { name: "Financial", id: 4 },
    { name: "NFO", id: 6 },
    { name: "Notice Ads", id: 7 },
    { name: "Other Disclosures", id: 8 },
    { name: "Portfolio Disclosure", id: 10 },
    { name: "Voting Policy", id: 13 },
  ];

  useEffect(() => {
    var para = window.location.pathname.toLocaleLowerCase().split('/')[2];
    if (para === "transactionservicerelatedforms") setValue(1)
    if (para === "factsheets") setValue(2)
    if (para === "schemerelateddocuments") setValue(5)

    if (para === "addendum") setValue(6)
    if (para === "noticeads") setValue(10)
    // if(para==="custodian")  setValue(8)
    // if(para==="registrars")  setValue(9)
  }, []);

  const FnSetCategoryId = useCallback((category) => {
    arrayOfTabsObj.filter((obj) => {
      if (obj.name === category) {
        //  console.log("category:"+JSON.stringify(obj));
        setCategoryId(obj.id);
      }
    });
  });
  useEffect(() => {
    setloadingshow(true);
    let pathName = window.location.pathname;
    var para = pathName.split('/')[2];
    FnSetCategoryId(para.replace(/-/g, ' '));
    setTitle(para.replace(/-/g, ' '));
    GetPostMethodData(BaseURL + "GetDownloadsById", {
      CategoryId: CategoryId,
      top: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
        // console.log((DecryptAESdata(data.data)),"dow")
      }
    });
  }, [BaseURL, CategoryId, FnSetCategoryId]);

  let PageSize = 10;

  const currentTableData = useMemo(() => {
    if (data != null) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      if (data != null) {
        if (data.length > 0) {
          return data.slice(firstPageIndex, lastPageIndex);
        }
      }
    }
  }, [currentPage, data, PageSize]);
  return (
    <>
      <section className="download-detail maring-bottom">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>{Title}</h2>
              </div>
              <div>
                {(currentTableData === null) ? <h5 className="errormsgComNew" role="alert">No Data Available</h5> : ''}
                {currentTableData &&
                  currentTableData.map(
                    ({ heading, category, filename, fileext }) => (
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={BaseURL.replace("api/", "") + filename}
                        // src={image}
                        download
                        className="pointer"
                      >
                        <div className="update-main">
                          <div className="update-data">
                            <h6>{category}</h6>
                            <h4>{heading}</h4>
                          </div>

                          <div className="pdf-img">
                            {fileext.toLowerCase() === ".pdf" ? (
                              <img src={pdf} alt="pdf" className="img-fluid" />
                            ) : fileext.toLowerCase() === ".xls" ||
                              fileext.toLowerCase() === ".xlsx" ? (
                              <img
                                src={excel}
                                alt="Excel"
                                className="img-fluid"
                              />
                            ) : fileext.toLowerCase() === ".xml" ? (
                              <img src={xml} alt="XML" className="img-fluid" />
                            ) : (
                              <img
                                src={word}
                                alt="Word"
                                className="img-fluid"
                              />
                            )}
                          </div>
                        </div>
                      </a>
                    )
                  )}
                {loadingshow ? <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                  <img src={animation} alt="" aria-hidden="true" />
                  <div className="model_popup">Please Wait...</div>
                </div> : ""
                }
                {data != null ? (
                  <Pagination
                    className="pagination-bar_peer"
                    currentPage={currentPage}
                    totalCount={data.length != null ? data.length : 0}
                    pageSize={PageSize}
                    showTitle = {false}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                ) : (
                  <p className="errorPeer" role="alert"> No Data Found</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default DownloadInner;
